"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const react_1 = require("react");
const useStripeCard = () => {
    const [error, setError] = (0, react_1.useState)(undefined);
    const [processing, setProcessing] = (0, react_1.useState)(false);
    const stripe = (0, react_stripe_js_1.useStripe)();
    const elements = (0, react_stripe_js_1.useElements)();
    const authorize = async () => {
        let token = null;
        setError(undefined);
        if (!stripe || !elements) {
            return;
        }
        const cardElement = elements.getElement(react_stripe_js_1.CardNumberElement);
        if (!cardElement) {
            return;
        }
        try {
            setProcessing(true);
            const response = await stripe.createToken(cardElement, { currency: 'usd' });
            if (response.error) {
                setError(response.error.message);
            }
            else {
                token = response.token;
            }
        }
        catch (error) {
            console.error(error.message);
        }
        finally {
            setProcessing(false);
        }
        return token;
    };
    return { error, processing, authorize };
};
exports.default = useStripeCard;
